import React from 'react';

import { formatMoney } from '@betterment/js-runtime';
import { Icon, ListRow, Text } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

import { PayrollContributionConfigFragment } from '../../../graphql/fragments/payrollContributionConfig.generated';

type Props = {
  config: PayrollContributionConfigFragment;
  showIcon?: boolean;
  showLabel?: boolean;
  css?: SystemStyleObject;
};

export const PayrollContributionConfigRow: React.FC<Props> = ({ config, showIcon = false, showLabel = false, css }) => {
  return (
    <ListRow key={config.id} css={{ ...css, alignItems: 'start' }}>
      {showIcon && (
        <ListRow.LeadingAsset>
          <Icon name="ArrowCirclePlus" size="small" />
        </ListRow.LeadingAsset>
      )}
      <ListRow.LeadingContent
        css={!showIcon ? { paddingTop: 'space.0', paddingLeft: 'space.400', marginLeft: 'space.50' } : undefined}
      >
        {contributionInfo(config)}
        {showLabel && (
          <Text variant="text50" color="text.weak">
            Base pay (per pay period)
          </Text>
        )}
      </ListRow.LeadingContent>
    </ListRow>
  );
};

function contributionInfo(config: PayrollContributionConfigFragment) {
  switch (config.value.__typename) {
    case 'PayrollContributionConfigValueAmount':
      return (
        <Text>
          {formatMoney(config.value.amount)} to {config.destinationName}
        </Text>
      );
    case 'PayrollContributionConfigValuePercent':
      return (
        <Text>
          {config.value.percent}% to {config.destinationName}
        </Text>
      );
    default:
      return '';
  }
}
